<template>
    <div class="main">
        <div class="title">
            <div class="name"> 意见反馈</div>
        </div>
        <div class="box flex flex-direction">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="auto"
                     class="ruleForm" v-loading="loading">
                <el-form-item ref="phone" label="联系电话" prop="phone" class="input-container">
                    <el-input v-model="ruleForm.phone" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item ref="content" label="反馈内容" prop="content" class="input-container">
                    <el-input v-model="ruleForm.content" placeholder="请输入"
                              type="textarea" :autosize="{ minRows: 5, maxRows: 5 }" resize="none"></el-input>
                </el-form-item>
            </el-form>
            <el-button class="input-form-btn margin-tb-sm self-center" type="warning"
                       @click="submitForm('ruleForm')" :loading="submit_loading">
                提交反馈
            </el-button>
        </div>
    </div>
</template>
<script>
import {feedback} from "@/api";

export default {
    name: "feedback",
    data() {

        return {
            ruleForm: {
                phone: '',//
                content: '',//
            },
            rules: {
                phone: [
                    {required: true, message: '请输入联系电话', trigger: 'blur'},
                    { required: true, pattern: /^1[0-9]{10}$/,message:'手机号码不正确', trigger: 'onChange' }
                ],
                content: [
                    {required: true, message: '请输入反馈内容', trigger: 'blur'},
                ]
            },
            loading: false,
            submit_loading: false,
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
    },
    components: {},
    created() {
        this.$emit("setActive", {
            active: 4,
            act: 1,
            name: '帮助与支持 > 意见反馈'
        })
    },
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitChange();
                } else {
                    return false;
                }
            });
        },
        async submitChange(){
            this.submit_loading = true
            let _data = await feedback(
                this.ruleForm.phone,
                this.ruleForm.content,
            )
            this.submit_loading = false
            if (_data.status === 200) {
                this.$message.success('提交成功')
                this.$refs.ruleForm.resetFields()
            } else {
                this.$message.error(_data.msg)
            }
        }

    },
    watch: {},
    filters: {}
}
</script>

<style scoped lang="scss">
.btn3 {
    display: block;
    width: 120px;
    height: 40px;
    background-color: #ff9600;
    border-radius: 20px;
    font-size: 14px;
    color: #ffffff;
    text-align: center;
    line-height: 40px;
    cursor: pointer;
}

.main {
    background-color: #ffffff;
    border-radius: 10px;

    .title {
        padding: 5px 8px 15px 8px;

        .name {
            font-size: 20px;
            color: #ffffff;
            font-weight: bold;
        }
    }

    .box {
        width: 100%;
        border-radius: 10px;
        padding: 20px;
        background-color: #ffffff;
    }
}
</style>


